<template>
	<div class="container">
		<p class="indent">天宏达安医药科技有限公司是一家面向全球，服务于新药及仿制药研发和生产的CDMO一站式综合服务商。公司恪守最高质量标准，凭借高度的专业性，优良的服务记录和丰富的项目管理经验，获得业界广泛认可。可满足国内外客户在药物研究各个阶段的不同需求，为客户提供原料药一体化整套的研发和生产服务，构建起创新药及仿制药一体化服务生态圈。</p>
	</div>
</template>
<script>
	export default {
		data() {
			return {
			}
		},
		mounted() {},
		methods: {
		}
	}
</script>

<style lang="scss" scoped>
	.container {
		width: 900px;
		display: flex;
		flex-direction: column;

		.image1 {
			width: 900px;
			height: 500px;
		}

		.title {
			font-size: 30px;
			font-weight: bold;
			color: #333333;
			padding: 40px 0;
		}
		.indent{
			text-indent: 2em;
		}
		p{
			font-size: 16px;
			color: #333333;
			margin-bottom: 30px;
		}
		.text{
			font-size: 18px;
			font-weight: bold;
			color: #004098;
			margin-bottom: 10px;
		}
		.census {
			width: 100%;
			height: 300px;
			position: relative;
			margin-bottom: 20px;
			.el-image {
				width: 100%;
				height: 300px;
			}
		
			.range {
				width: 100%;
				height: 300px;
				position: absolute;
				top: 0;
				left: 0;
				background-color: rgba($color: #004098, $alpha: 0.8);
				display: flex;
				align-items: center;
				flex-wrap: wrap;
				justify-content: space-between;
				
				.li {
					width: 25%;
					height: 150px;
					font-size: 16px;
					color: #fff;
					display: flex;
					align-items: center;
					justify-content: center;
					flex-direction: column;
				
					.el-image {
						width: 50px;
						height: 50px;
						margin-bottom: 10px;
					}
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/service/cdmo.vue